import React, { Component } from 'react';
import { Upload, Icon, message, Dropdown, Menu, Input } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { getIndexedDBData, putIndexedDBData } from './../../utils/indexedDBUtil';

import {
  TabMenuContainer,
  TabMenuHeader,
  TabMenuItemContainer,
  TabMenuItemDetails,
  DragContainer,
  HelpGuideWrapper,
  LoaderContainer,
  EmptyElements,
  TabSearchContainer,
  SearchNavWrapper,
} from './styles';

import DeleteImageModal from '../../components/Modals/DeleteImageModal';
import GenerateImageModal from '../../components/Modals/GenerateImageModal';
import { uploadImage } from '../../utils/services/uploadAPI';
import { clickToDownload, getBase64, getFileBlob } from '../../utils/javascript';
import Loader from '../../components/Loader';
import { getAllImages } from '../../utils/services/imageAPI';
import { DESIGN_AREA_UPLOADS_TAB } from './translationValues';
import SessionContext from '../../context/sessionContext';

// app store context API
import { Container, LoaderView } from '../../components/EditorElement/styles';
import { withTranslation } from 'react-i18next';
import axiosCall from '../../utils/services/interceptor';
import VisibilitySensor from 'react-visibility-sensor';

const { Dragger } = Upload;
const accept = '.png,.jpeg,.jpg,.svg';
const acceptedExtension = ['png', 'jpeg', 'jpg', 'svg'];
const NAMESPACES = ['DESIGN_AREA_UPLOADS_TAB']

class UploadsTabDetails extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      fetchingImages: !props.isOpenDesign,
      modalVisibility: false,
      imageData: 0,
      selectedImage: null,
      userType: context.userData?.userType,
      showGenerate: false,
      uploadedElements: [],
      searchText: '',
      isSearched: false,
    };
    this.searchText = React.createRef();
    this.width = React.createRef();
    this.height = React.createRef();
  }

  componentDidMount() {
    this.fetchData();
  }

  updateUploadElements = (elements, updationType) => {
    const { uploadedElements } = this.state;
    switch (updationType) {
      case 'saveAllUploadElements':
        this.setState({
          uploadedElements: elements
        });
        break;
        case 'addNewUploadElement':
          let uploadsList = JSON.parse(JSON.stringify(uploadedElements));
          this.setState({
            uploadedElements: [elements, ...uploadsList],
            imageData: this.state.imageData - 1
          });
        break;
      case 'deleteUploadElement':
        if (elements.id) {
          const copiedUploadedList = JSON.parse(JSON.stringify(uploadedElements));
          this.setState({
            uploadedElements: copiedUploadedList.filter(upload => upload.id !== elements.id)
          });
        }
        break;
      default:
        break;
    }
  };

  fetchData = async () => {
    const { userType, searchText } = this.state; 
    this.setState({ fetchingImages: true });
    if (!this.props.isOpenDesign) {
      let params = {
        userType,
      }
      if(searchText !== '') {
        params.name = searchText;
      }
      let response = await getAllImages(params);
      if (response && response.data) {
        this.updateUploadElements(response.data, 'saveAllUploadElements');
        this.setState({
          fetchingImages: false,
        });
      }
    } else {
      const openImages = await getIndexedDBData('openImages');
      console.log({ openImages });
      this.updateUploadElements(openImages || [], 'saveAllUploadElements');
      this.setState({
        fetchingImages: false,
      });
    }
  };

  customRequest = async ({ file, onSuccess }) => {
    let fileName = file.name.split('.');
    let fileType = file.type.replace('/', ',').split(',');
    let fileExtension = file.name.split('.')[file.name.split('.').length - 1].toLowerCase();
    let isValidFileExtension = acceptedExtension.some(data => {
      return data === fileExtension;
    });
    const url = await getBase64(file);
    const data = { file, thumbnail: url, name: file.name, id: uuidv4(), path: `${fileType[0]}/${file.name}`, };
    const newFile = {
      uid: uuidv4(),
      name: fileName[0],
      type: fileType[0],
      isLoading: true,
      id: undefined,
      path: `${fileType[0]}/${file.name}`,
      userType: this.state.userType,
      imageLink: url,
    };
    if (!isValidFileExtension) {
      message.error(
        this.props.t(
          DESIGN_AREA_UPLOADS_TAB.UPLOADED_IMAGE_FILE_EXTENSION_ERROR_MESSAGE.key,
          DESIGN_AREA_UPLOADS_TAB.UPLOADED_IMAGE_FILE_EXTENSION_ERROR_MESSAGE.value,
        ) + ' ' + acceptedExtension.join(', '),
      )
    } else {
      this.setState(
        {
          imageData: this.state.imageData + 1,
        },
        async () => {
          const uploadResponse = await this.onSubmit(data);
          if (uploadResponse && uploadResponse?.imageLink !== undefined) {
            newFile.imageLink = uploadResponse.imageLink;
            newFile.id = uploadResponse.id;
            this.updateUploadElements(newFile, 'addNewUploadElement');
          } else {
            this.setState({
              imageData: this.state.imageData - 1,
            });
          }
        }
      )
      onSuccess(this.props.t(DESIGN_AREA_UPLOADS_TAB.IMAGE_OK_TEXT.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_OK_TEXT.value));
      this.props.ScrollToTop();
    }
  };

  onSubmit = async data => {
    if (this.props.isOpenDesign) {
      // const blob = await getFileBlob(data.file);
      const blobURL = URL.createObjectURL(data.file);
      console.log({ data, blobURL });
      const newImage =  {
        imageLink: data.thumbnail,
        userType: 'master',
        path: data.path,
        id: data.id
      };
      const allImages = await getIndexedDBData('openImages');
      await putIndexedDBData('openImages', [...(allImages || []), newImage]);
      return newImage;
    } else {
      let response = await uploadImage(data.file, data.name);
      if (response && response?.statusCode === 101) {
        // message.success(response.status);
        return response;
      } else {
        return false;
      }
    }
  };

  handleMenu = element => {
    this.setState({
      modalVisibility: true,
      selectedImage: element,
    });
  };

  closeModal = () => {
    this.setState({
      modalVisibility: false,
      selectedImage: null,
      imageData: 0,
    });
  };

  emptyImageView = () => (
    !this.state.isSearched ?
    <EmptyElements className="full-width">
      <div className="empty-illustration">
        <Icon type="upload" style={{ color: 'white' }} />
      </div>
      <div className="empty-txt">
        <span>{this.props.t(DESIGN_AREA_UPLOADS_TAB.IMAGE_DROP_AREA_PLACEHOLDER.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_DROP_AREA_PLACEHOLDER.value)}</span>
      </div>
    </EmptyElements>
    :
    <EmptyElements className="full-width">
      <div className="empty-illustration">
          <Icon type="search" style={{ color: 'white' }} />
        </div>
      <div className="empty-txt">
          <span>{this.props.t(DESIGN_AREA_UPLOADS_TAB.IMAGE_NOT_FOUND_MESSAGE.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_NOT_FOUND_MESSAGE.value)}</span>
      </div>
    </EmptyElements>    
  );

  renderSearchBar = () => {
    const { searchText } = this.state;
    return (
      <TabSearchContainer
        isComplex
      >
        <Input
          name="templateSearch"
          placeholder={this.props.t(DESIGN_AREA_UPLOADS_TAB.SEARCH_PLACEHOLDER.key, DESIGN_AREA_UPLOADS_TAB.SEARCH_PLACEHOLDER.value)}
          value={searchText}
          onChange={e => this.setState({ searchText: e.target.value })}
          onPressEnter={() => {
            if(searchText.trim().length > 0)
            this.setState({ isSearched: true }, () => this.fetchData()) }}
          style={{ width: 200 }}
          prefix={<Icon type="search" />}
          autoComplete={'off'}
          suffix={
            <>
              {
                <Icon
                  type="close"
                  onClick={() =>
                    this.setState({ searchText: '', isSearched: false }, () => {
                      this.fetchData();
                    })
                  }
                />
              }
            </>
          }
        />
      </TabSearchContainer>
    );
  };

  downloadImage = async (name, url) => {
    const { data } = await axiosCall('get', url, { responseType: 'blob' }, false);
    clickToDownload(data, name);
  };

  uploadedImageView = () => {
    return (
      <TabMenuItemContainer>
        {this.state.imageData > 0 &&
          Array(this.state.imageData).fill(0).map((element, index) => {
            return (
              <TabMenuItemDetails key={`loadingimage${index}`} type="image">
                <Container style={{ minHeight: 150 }}>
                  <LoaderView>
                    <Loader />
                  </LoaderView>
                </Container>
              </TabMenuItemDetails>
            );
          })}

        {this.state.uploadedElements &&
          this.state.uploadedElements.length > 0 &&
          this.state.uploadedElements.map(element => {
            const isSvg = element.path?.endsWith('.svg');
            const thumbnail = element.imageLink;
            let elementObj = {
              id: element.id,
              name: element.name,
              thumbnail: thumbnail,
              type: 'colored',
              elementDetails: {
                styles: {
                  position: 'absolute',
                  backgroundColor: 'transparent',
                },
                type: 'image',
                value: thumbnail,
              },
            };
            let uploadOption = {
              id: element.id,
              path: element.path,
              userType: element.userType,
            };
            return (
              <VisibilitySensor partialVisibility key={element.id}>
                {({isVisible}) =>  {
                    return <TabMenuItemDetails key={`${element.id}-image`} type="image">
                      {isVisible && this.props.renderElement(elementObj, isSvg)}
                      {!this.props.isOpenDesign && <div className="element-meta" id={`${element.id}-element`}>
                        <Dropdown
                          overlay={
                            <Menu>
                              <Menu.Item key="0" onClick={() => this.handleMenu(uploadOption)}>
                                {this.props.t(DESIGN_AREA_UPLOADS_TAB.DELETE_IMAGE_DROPDOWN_OPTION.key, DESIGN_AREA_UPLOADS_TAB.DELETE_IMAGE_DROPDOWN_OPTION.value)}
                              </Menu.Item>
                              <Menu.Item key="1" onClick={() => this.downloadImage(element.name, element.imageLink)}>
                                {this.props.t(DESIGN_AREA_UPLOADS_TAB.DOWNLOAD_IMAGE_DROPDOWN_OPTION.key, DESIGN_AREA_UPLOADS_TAB.DOWNLOAD_IMAGE_DROPDOWN_OPTION.value)}
                              </Menu.Item>
                            </Menu>
                          }
                          trigger={['click']}
                          getPopupContainer={() => document.getElementById(`${element.id}-element`)}
                        >
                          <Icon type="more" />
                        </Dropdown>
                      </div>}
                    </TabMenuItemDetails>
                  }
                }
              </VisibilitySensor>
            );
          })}
        {this.state.uploadedElements &&
          this.state.uploadedElements.length === 0 &&
          this.emptyImageView()}
      </TabMenuItemContainer>
    );
  };

  generateImages = () => {
    this.setState({ showGenerate: true });
  }

  uploadButtonView = () => (
    <HelpGuideWrapper>
      <div className="help-container upload-helper">
        <Upload
          customRequest={this.customRequest}
          showUploadList={false}
          accept={accept}
          multiple={true}
        >
          <div className="help-action-btn">
            <Icon type="upload" />{this.props.t(DESIGN_AREA_UPLOADS_TAB.UPLOAD_IMAGES_BUTTON.key, DESIGN_AREA_UPLOADS_TAB.UPLOAD_IMAGES_BUTTON.value)}
          </div>
        </Upload>
      </div>
    </HelpGuideWrapper>
  );

  render() {
    const { t, isOpenDesign } = this.props;
    const { fetchingImages, uploadedElements, isSearched } = this.state;
    return (
      <TabMenuContainer>
        {this.state.fetchingImages && (
          <LoaderContainer>
            <Loader />
            <div className="loading-txt">{t(DESIGN_AREA_UPLOADS_TAB.IMAGE_LOADING.key, DESIGN_AREA_UPLOADS_TAB.IMAGE_LOADING.value)}</div>
          </LoaderContainer>
        )}

        {!isOpenDesign && <SearchNavWrapper>
          {this.renderSearchBar()}
        </SearchNavWrapper>}

        {!fetchingImages &&
          uploadedElements &&
          uploadedElements.length > 0 &&
          !isSearched &&
           (
            <TabMenuHeader isImageCount={true}>
              {t(DESIGN_AREA_UPLOADS_TAB.UPLOADED_IMAGES_COUNT.key, DESIGN_AREA_UPLOADS_TAB.UPLOADED_IMAGES_COUNT.value)}
              {uploadedElements &&
                uploadedElements.length > 0 &&
                `(${uploadedElements.length})`}
            </TabMenuHeader>
          )}

        {!this.state.fetchingImages && (
          <TabMenuItemContainer>
            <DragContainer isSearched={isSearched}>
              <Dragger
                openFileDialogOnClick={!(this.state.uploadedElements.length > 0)}
                accept={accept}
                customRequest={this.customRequest}
                showUploadList={false}
                multiple={true}
                disabled={isSearched}
              >
                {this.uploadedImageView()}
              </Dragger>
            </DragContainer>
          </TabMenuItemContainer>
        )}

        {!this.state.fetchingImages &&
          this.uploadButtonView()}
        {this.state.modalVisibility && (
          <DeleteImageModal
            type="image"
            displayText={t(DESIGN_AREA_UPLOADS_TAB.DELETE_IMAGE_MODAL_DISPLAY_TEXT.key, DESIGN_AREA_UPLOADS_TAB.DELETE_IMAGE_MODAL_DISPLAY_TEXT.value)}
            visible={this.state.modalVisibility}
            target={this.state.selectedImage}
            onCancel={this.closeModal}
            onDeleteImage={this.updateUploadElements}
          />
        )}
        {this.state.showGenerate && (
              <GenerateImageModal
                visible={this.state.showGenerate}
                onClose={() => { this.setState({ showGenerate: false }); }}
                onSelect={(data, cb) => {
                  this.setState(
                      {
                        imageData: this.state.imageData + 1,
                      },
                      async () => {
                        cb();
                        const newFile = {
                          uid: uuidv4(),
                          name: data.name,
                          type: data.type,
                          isLoading: true,
                          thumbnail: data.binary,
                          id: undefined,
                          userType: this.state.userType
                        };
                        const uploadImageId = await this.onSubmit({ file: data.blob, name: data.name });
                        if (uploadImageId !== undefined) {
                          newFile.id = uploadImageId;
                          this.updateUploadElements(newFile, 'addNewUploadElement');
                        } else {
                          this.setState({
                            imageData: this.state.imageData - 1,
                          });
                        }
                      }
                  );
                }}
              />
            )}
      </TabMenuContainer>
    );
  }
}

UploadsTabDetails.contextType = SessionContext;

export default withTranslation(NAMESPACES)(UploadsTabDetails);
